/*************************************************************************
*
*  Copyright 2023 Adobe
*  All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

const formScopedMarkerName = markerName => `provider_rendition_${markerName}`;

// eslint-disable-next-line import/prefer-default-export
export const recordNow = (marker, time) => {
    const startTime = Math.round(time || performance.now());
    if (window.performance && window.performance.mark) {
        window.performance.mark(formScopedMarkerName(marker), { startTime });
    }
    return startTime;
};
